import { useEffect } from "react";

export const useUpdatePageViewsCount = () => {
    useEffect(async () => {
        // initialise with a small negative to trigger contest info modal to show
        let pageViwsCount = sessionStorage.getItem('pageViewsCount') || -10;

        sessionStorage.setItem('pageViewsCount', ++pageViwsCount);
    }, []);
}